import axios from 'axios';
import { verifySecurityEndpoint } from './endpoints';
import { getRequestHash } from '../utils/helpers';
import CustomError from '../utils/customError';
// import mockOperationData from '../mock/mockOperationData';
import userDataParser from '../utils/userDataParser';


const getVerifySecurity = async (setOperationData, setError) => {
  try {
    const requestHash = getRequestHash();
    if (!requestHash) {
      throw new CustomError({
        type: 'Not Found',
        message: '404 - Página no encontrada.',
      });
    }

    // verify security operation
    const response = await axios.post(verifySecurityEndpoint(requestHash));
    
    if (parseInt(response.status) !== 200) {
      throw new CustomError({
        type: 'Error Fetching Data',
        message: 'Error al recuperar la información del usuario.',
      });
    }
    
    if (!response.data) {
      throw new CustomError({
        type: 'Request Not Found',
        message: 'No se ha encontrado un pedido asociado.',
      });
    }
    
    if (!response.data.security) {
      const operationId = response.data.id;
      const unparsedData = response.data; // full raw data
      const parsedUserData = userDataParser(unparsedData); // parsed data for generating contract and displaying user info
      setOperationData(unparsedData, parsedUserData);
      return { security: false, unparsedData, parsedUserData, operationId };
    } else {
      return { security: true };
    };

  } catch (error) {
    console.log(error.response.data.key);
    return { error: error.response.data.extra.key }
  }
};

export default getVerifySecurity;
